export default {
    iKnow: '已了解',
    yzmfssb: '验证码发送失败',

    oldEmail: {
        desc1: '当前认证邮箱可用于找回密码，',
        desc2: '如该邮箱不再适用，请及时更新',
        change: '修改认证邮箱',
    },

    captcha: {
        inputEmailCode: '输入邮箱验证码',
        sentEmailTo: '已发送邮箱验证码至：',
        resend: '重新发送',
        notReceive: '收不到验证码',
        connectUs: '联系我们',
        dlkf: '内地客服：',
        xgkf: '香港客服：',
        wrongCaptcha: '验证码错误或失效，请重新输入',
        repeatTips: '60s内无须重复获取验证码',
        wrongEmail: '邮箱验证失败或已失效，请重新输入',
        wrongTooMuch: '验证次数过多，请稍后重试',
    },

    newEmail: {
        changeEmail: '设置新认证邮箱',
        desc: '修改后您可以通过新邮箱找回密码',
        inputEmail: '请输入邮箱地址',
        sendCode: '发送确认邮件',
        syncAccountEmail: '同步更新证券账户认证的邮箱',
        syncAccountEmailTitle: '同步更新证券账户信息说明',
        info1: '您正在更新平台邮箱信息，主要用于登录账号和找回密码。系统将同步更新您的证券账户绑定的邮箱。',
        info2: '如您需要为星财号和证券账户设置不同邮箱，请联系客服修改。',
        dlkf: '内地客服：',
        xgkf: '香港客服：',
        inputCorrectEmail: '请输入正确的邮箱地址',
        notSameEmail: '新邮箱不可与当前一致',
    },

    identity: {
        title: '身份验证',
        desc: '请填写开户证件号进行身份验证，开户证件号不区分大小写，且无须输入括号',
        idNumber: '开户证件号',
        nextStep: '下一步',
        desc1: '开户证件号不区分大小写字母。如是香港身份证无须输入括号。',
        desc2: '示例如下：',
        example1: '香港身份证：G1234567',
        example2: '内地身份证：12345678901234567X',
        example3: '内地护照：E12345678',
        wrongIdNumber: '身份验证失败，请重新输入',
    },

    result: {
        success: '修改成功',
        desc: '认证邮箱已修改成功',
        finish: '完成',
    },
}
